<template lang="pug">
.content.tree(:id='getId')
  div.rule-wrapper(:style='indent')
    //- p RuleId = {{id}}
    //- p {{children}}
    //- p {{conditions}}
    //- p {{actions}}
    .well.well-sm(ref='ruleRaw')
      div(
        v-if="label === 'IF' && dragStarted"
        class='dd-overlay'
        v-on:drop="drop"
        v-on:dragover="allowDrop"
        v-on:dragleave="dragLeave"
      )
      div(class='dd-icon' v-tooltip="'Grab to reorder'" draggable v-if="label == 'IF'" v-on:dragstart='dragStart' v-on:drag='dragging' v-on:dragend='dragEnd')
      condition(
        :conditions='conditions'
        :label='label'
        :rule='self'
        ref='conditionLine'
        :conditionOptions='conditionOptions'
        @updateCondition='updateCondition'
        @copyLine='copyLine'
        @deleteLine='deleteLine'
        @addLine='addLine'
        @changeOperator='changeOperator'
      )
        div.col-md-1.text-right.fas.fa-trash-alt.pull-right(@click='deleteConditionModal()' slot='delete-condition')
        //- div.fas.fa-arrows-alt.col-md-1.pull-right(@click='' slot='delete-condition')

      action(
        v-if='actions && actions[type.action]'
        :actions='actions'
        :rule='self'
        ref='actionLine'
        :actionOptions='actionOptions'
        :routeValues='routeValues'
        @updateAction='updateAction'
        @copyLine='copyActionLine'
        @deleteLine='deleteActionLine'
        @addActionLine='addActionLine'
        @changeOperator='changeActionOperator'
        :useParallelApprovalRoutes='useParallelApprovalRoutes'
        )
        div.col-md-1.text-right.fas.fa-trash-alt.pull-right(@click='deleteActionModal()' slot='delete-action')
        //- div.fas.fa-arrows-alt.col-md-1.pull-right(@click='' slot='delete-action')

      .toolbar
        ed-button.btn.btn-actionbar(@click='addCondition(con)') ADD CONDITION
        ed-button.btn.btn-actionbar(
            v-if='depth < 2'
            @click='addRuleGroup') ADD RULE GROUP
        ed-button.btn.btn-actionbar(@click='addAction') ADD ACTION

    rule(
      v-for='child in list(children)'
      :key='child'
      :self='child'
      :children='child.Children && list(child.Children[type.rule])'
      :depth='depth + 1'
      :conditions='child.Conditions !== undefined && child.Conditions'
      :actions='child.Actions !== undefined && child.Actions'
      :label='"IF"'
      :conditionOptions='conditionOptions'
      :actionOptions='actionOptions'
      :routeValues='routeValues'
      :useParallelApprovalRoutes='useParallelApprovalRoutes'
      )

  ed-modal(
    :show='showDeleteIfGroup'
    @close='showDeleteIfGroup = false'
    @confirm='deleteConditionGroup'
    title=''
    subtitle='Are you sure you want to delete this rule group?'
    primaryButton='Yes'
    secondaryButton='No'
    type='small'
  )

  ed-modal(
    :show='showDeleteThenGroup'
    @close='showDeleteThenGroup = false'
    @confirm='deleteActionGroup'
    title=''
    subtitle='Are you sure you want to delete this group of actions?'
    primaryButton='Yes'
    secondaryButton='No'
    type='small'
  )

</template>

<script>

import Condition from './condition'
import Action from './action'
import Rule from './rule'
import type from './type'
import { EventBus } from '@/event-bus'
import events from '@/core/events/events'
var approvalRuleUtils = require('./approvalRuleUtils')

export default {
  components: {
    Condition,
    Action,
    Rule
  },

  props: {
    self: Object,
    children: Array,
    depth: Number,
    conditions: Object,
    actions: Object,
    label: String,
    conditionOptions: Object,
    actionOptions: Object,
    routeValues: Array,
    useParallelApprovalRoutes: Boolean
  },

  name: 'rule',

  data() {
    return {
      utils,
      conditionsCopy: utils.copy(this.conditions),
      type,
      list: utils.collection.list,
      max: utils.collection.max,
      isEmpty: utils.collection.isEmpty,
      showDeleteIfGroup: false,
      showDeleteThenGroup: false,
      componentDestroyed: false,
      dragStarted: false
    }
  },

  created() {
    var rulesArray = this.list(this.self)
    for (var i = 0; i < rulesArray.length; i++) {
      this.$store.state.approvalRuleIds.ruleIds.push(rulesArray[i].Id)
    }

    if (this.conditions && this.conditions[type.condition]) {
      var conditionsArray = this.list(this.conditions[type.condition])
      for (var j = 0; j < conditionsArray.length; j++) {
        this.$store.state.approvalRuleIds.conditionIds.push(conditionsArray[j].Id)
      }
    }

    if (this.actions && this.actions[type.action]) {
      var actionsArray = this.list(this.actions[type.action])
      for (var k = 0; k < actionsArray.length; k++) {
        this.$store.state.approvalRuleIds.actionIds.push(actionsArray[k].Id)
      }
    }

    EventBus.$on(events.APPROVAL_RULE.VALIDATE_COMPONENTS, this.validateRule)

    EventBus.$on('onDragStarted', this.onDragStarted)
  },

  // solution from this link does not work
  // https://stackoverflow.com/questions/45399302/stop-receiving-events-from-destroyed-child-component
  beforeDestroy() {
    this.componentDestroyed = true
  },

  computed: {
    getId() {
      return 'dd-' + this.self.Id
    },

    indent() {
      return { paddingLeft: `${this.depth ? 20 : 0}px` }
    },

    isRoot() {
      return this.depth === 0
    },

    newCondition() {
      return {
        Id: 0,
        '@xsi:type': '',
        __selectedOptions: [],
        __selectedContextType: '',
        __o: [{}],
        conditionValues: []
      }
    },

    newAction() {
      return {
        Id: 0,
        '@xsi:type': '',
        __selectedOptions: [],
        __selectedContextType: '',
        __o: [{}],
        actionValues: []
      }
    }
  },

  methods: {
    validateRule() {
      if (!this.componentDestroyed) {
        let valid = true

        // verify general conditions on rule
        if (!this.self.Conditions || (this.self.Conditions && (!this.self.Conditions[type.condition] || this.list(this.self.Conditions[type.condition]).length === 0))) {
          valid = false
        }
        if (!this.self.Operator) {
          valid = false
        }
        if ((!this.self.Children || (this.self.Children[type.rule] &&
          Array.isArray(this.self.Children[type.rule]) && this.self.Children[type.rule].length === 0)) &&
          (!this.self.Actions || !this.self.Actions[type.action] || this.list(this.self.Actions[type.action]).length === 0)) {
          valid = false
        }

        if (!valid) {
          this.invalidateConditionBlock()
        } else {
          this.resetConditionBlock()
        }

        let payload = {
          Id: this.self.Id,
          valid: valid
        }
        EventBus.$emit(events.APPROVAL_RULE.VALIDATION_COMPLETED, payload)
        EventBus.$emit('%Saved Approval Rule')
      }
    },

    invalidateConditionBlock() {
      if (this.$refs.ruleRaw && this.$refs.ruleRaw.classList) {
        this.$refs.ruleRaw.classList.add('invalid')
      }
    },

    resetConditionBlock() {
      if (this.$refs.ruleRaw && this.$refs.ruleRaw.classList) {
        this.$refs.ruleRaw.classList.remove('invalid')
      }
    },

    addLine(r) {
      let copyConditions = this.list(this.conditions[type.condition])
      copyConditions.push(r)
      this.conditions[type.condition] = copyConditions.length === 1 ? copyConditions[0] : copyConditions
    },

    updateCondition(r) {
      let idToFind = r.Id
      let updatedCondition = r.Condition
      let copyConditions = this.list(utils.copy(this.conditions[type.condition]))
      let updated = false

      copyConditions = copyConditions.map(cond => {
        if (cond.Id === idToFind) {
          cond = updatedCondition
          updated = true
        }
        return cond
      })

      if (updated) {
        this.conditions[type.condition] = copyConditions.length === 1 ? copyConditions[0] : copyConditions
      }

      this.$forceUpdate()
    },

    updateAction(r) {
      let idToFind = r.Id
      let updatedAction = r.Action

      let copyActions = this.list(utils.copy(this.actions[type.action]))
      let updated = false

      copyActions = copyActions.map(action => {
        if (action.Id === idToFind) {
          action = updatedAction
          updated = true
        }
        return action
      })

      if (updated) {
        this.actions[type.action] = copyActions.length === 1 ? copyActions[0] : copyActions
      }
    },

    changeOperator(r) {
      this.Operator = r
    },

    changeActionOperator(r) {
      this.ActionOperator = r
    },

    copyLine(r) {
      let copyConditions = this.list(this.conditions[type.condition])
      copyConditions.push(r)
      this.conditions[type.condition] = copyConditions
    },

    deleteLine(r) {
      let copyConditions = this.list(this.conditions[type.condition])
      copyConditions = copyConditions.filter(condition => condition.Id !== r.Id)
      this.conditions[type.condition] = copyConditions.length === 1 ? copyConditions[0] : copyConditions
    },

    addActionLine(r) {
      let copyActions = this.list(this.actions[type.action])
      copyActions.push(r)
      this.actions[type.action] = copyActions.length === 1 ? copyActions[0] : copyActions
    },

    copyActionLine(r) {
      let copyActions = this.list(this.actions[type.action])
      copyActions.push(r)
      this.actions[type.action] = copyActions
    },

    deleteActionLine(r) {
      let copyActions = this.list(this.actions[type.action])
      copyActions = copyActions.filter(action => action.Id !== r.Id)
      this.actions[type.action] = copyActions.length === 1 ? copyActions[0] : copyActions
    },

    deleteConditionModal() {
      this.showDeleteIfGroup = true
    },

    deleteActionModal() {
      this.showDeleteThenGroup = true
    },

    deleteConditionGroup() {
      if (this.$parent && this.$parent.self && this.$parent.self.Children && this.$parent.self.Children[type.rule]) {
        var siblings = this.$parent.self.Children[type.rule]

        if (this.list(siblings).length === 1) {
          this.$parent.self.Children = null
        } else {
          if (this.list(siblings).length > 1) {
            siblings.splice(siblings.indexOf(this.self), 1)
          }
        }
      }
      this.enableSaveButton()
    },

    deleteActionGroup() {
      this.self.Actions = {}
      delete this.self.ActionOperator
      this.enableSaveButton()
    },

    addRuleGroup() {
      this.enableSaveButton()
      var newRule = {
        Id: this.max(this.$store.state.approvalRuleIds.ruleIds) + 1,
        Children: null,
        Conditions: {
          ConditionDTO: []
        },
        Actions: {}
      }

      this.newCondition.Id = this.max(this.$store.state.approvalRuleIds.conditionIds) + 1
      newRule.Conditions[type.condition].push(utils.copy(this.newCondition))

      // No rules yet
      if (!this.self.Children) {
        let children = {}
        children[type.rule] = []
        children[type.rule].push(newRule)
        this.self.Children = children
        return
      }

      // Existing rules
      if (this.self.Children[type.rule].constructor === Array) {
        this.self.Children[type.rule].push(newRule)
        return
      }

      // One rule
      if (this.self.Children[type.rule].constructor === Object) {
        this.self.Children[type.rule] = this.list(this.self.Children[type.rule]).concat(newRule)
        return
      }
    },

    addCondition() {
      this.$refs.conditionLine.addCondition(this.newCondition)
      this.enableSaveButton()
    },

    addAction() {
      this.enableSaveButton()
        // No rules yet
      if (this.isEmpty(this.self.Actions) || (this.self.Actions[type.action] && this.self.Actions[type.action].length === undefined) === undefined) {
        if (this.$store.state.approvalRuleIds.actionIds.length > 0) {
          this.newAction.Id = this.max(this.$store.state.approvalRuleIds.actionIds) + 1
        } else {
          var firstActionId = (this.self.Id * 100)
          this.newAction.Id = firstActionId
        }
        this.$store.state.approvalRuleIds.actionIds.push(this.newAction.Id)

        var copyNewAction = utils.copy(this.newAction)
        let newActions = {}
        newActions[type.action] = copyNewAction
        this.self.Actions = newActions

        return
      } else {
        this.$refs.actionLine.addAction(this.newAction)
      }
    },

    enableSaveButton() {
      approvalRuleUtils.utils.enableSaveButton(!this.$store.state.enableSaveButton)
    },

    onDragStarted(payload) {
      if (this) {
        this.dragStarted = payload.data.started
      }
    },

    dragStart(event) {
      EventBus.$emit('onDragStarted', {
        started: true
      })

      // make it half transparent
      event.dataTransfer.effectAllowed = 'copyMove'

      // store a ref. on the dragged elem
      let id = this.self.Id

      let row = document.querySelector(`#dd-${id}`)
      let rowClone = row.cloneNode(true)
      row.classList.add('dd-over-start')
      rowClone.classList.add('dd-ghost')
      rowClone.classList.add('ag-row-dragging')
      rowClone.style.width = `1030px`
      rowClone.id = ''

      document.body.appendChild(rowClone)

      event.dataTransfer.setDragImage && event.dataTransfer.setDragImage(rowClone, 0, 0)
      event.dataTransfer.setData('text/plain', id)
    },

    dragging(event) {
      event.preventDefault()
      let id = this.self.Id
      let row = document.querySelector(`#dd-${id}`)
      row.classList.remove('dd-over-start')
      this.$parent.draggingFromId = id
    },

    allowDrop(event) {
      const fromId = this.$parent.$parent.draggingFromId
      const parentId = this.$parent.self.Id
      let id = this.self.Id
      let row = document.querySelector(`#dd-${id}`)
      if (fromId !== parentId) {
        row.classList.add('dd-over')
      } else {
        row.classList.add('dd-over-not-allowed')
      }
      event.preventDefault()
    },

    dragLeave(event) {
      let id = this.self.Id
      let row = document.querySelector(`#dd-${id}`)
      row.classList.remove('dd-over')
      row.classList.remove('dd-over-start')
      row.classList.remove('dd-over-not-allowed')
    },

    dragEnd(event) {
      let id = this.self.Id
      let row = document.querySelector(`#dd-${id}`)
      row.classList.remove('dd-over')
      row.classList.remove('dd-over-not-allowed')

      event.preventDefault()
      event.stopPropagation()

      EventBus.$emit('onDragStarted', {
        started: false
      })
    },

    drop(event) {
      // prevent default action (open as link for some elements)
      event.preventDefault()
      event.stopPropagation()

      // find ID of the dragged elem
      let fromId = +event.dataTransfer.getData('text/plain')
      event.dataTransfer.clearData()

      if (event.target.className === 'dd-overlay' && +this.self.Id !== fromId) {
        let fromNode = document.querySelector('#dd-' + fromId)
        // avoid drop parent before child (error: The new child element contains the parent)
        let canMoveElement = !(this.depth === 2 && fromNode && this.$el.parentNode && fromNode === this.$el.parentNode.parentNode)
        if (fromNode && canMoveElement) {
          // move dragged elem to the selected drop target
          fromNode.parentNode.removeChild(fromNode)
          this.$el.parentNode.insertBefore(fromNode, this.$el)

          // avoid beeing marked as destroyed
          this.componentDestroyed = false

          // allow rule to be saved
          this.enableSaveButton()

          // update order in RuleDTO object
          EventBus.$emit(events.APPROVAL_RULE.UPDATE_RULE.MOVE_RULE, {
            fromRuleId: fromId,
            toRuleId: +this.self.Id
          })
        }
      }

      this.dragEnd(event)
    }
  }
}

</script>

<style lang='scss'>
@import '~@/assets/sass/_variables.scss';

.row {
  > label {
    line-height: 2.3rem;
    margin-top: 8px;
    margin-left: -1px;
    //margin-bottom: -3px;
  }
  > .fa, > .fas, > .far, > .fal {
    margin-top: 8px;
  }
}

.dd-overlay {
  width: 100%;
  height: 78%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

.dd-over .rule-wrapper > .well,
.dd-over-start .rule-wrapper > .well
{
  // opacity: 0.35;
  margin: -4px -4px -5px -4px !important;
  @include theme {
  border: 4px solid v(secondary-01) !important;
  }
  border-radius: 4px !important;
  z-index: 99;
}
.dd-over {
  [id^=dd-] .rule-wrapper > .well {
    @include theme {
    border: 4px solid v(urgent-01) !important;
    }
  }
}
.dd-over-not-allowed .rule-wrapper > .well {
  @include theme {
  border: 4px solid v(urgent-01) !important;
  }
}

.dd-ghost {
  background: #faffaa;
  border: 1px solid #ffdd00;
  color: #000;
}

.dd-icon {
  @include drag-handle;
  width: 10px;
  cursor: grab;
  margin-right: 5px;
  margin-top: 21px;
  float: left;
  position: absolute;
  left: 0;
  // top: 0;
  z-index: 99;
}

.content.tree {
  .invalid {
    background: #ffb3b3 !important;
  }
  .well {
    background: none;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    margin: 0;
    border: 0;
    position: relative;

    .icon-bar {
      background: #fff;
      min-height: 1.85rem !important;
      border-left: 1px solid #ccc;

      text-align: right;
      padding-left: 0;
      float: right;
      .fa, .fas, .far, .fal {
        margin-left: 10px;
      }
    }
    .fa, .fas, .far, .fal {
      line-height: 2rem;
      font-size: 13px;
      height: 13px;
      cursor: pointer;
      color: #b3b3b3;

      &:hover {
        color: #888;
      }
    }

    > .row {
      margin-left: -1px !important;
      margin-right: -1px !important;
      border-top: none;
    }
  }

  .row {
    border: 1px solid #ccc;
    margin: -1px;
    clear: both;

    > .row {
      margin-left: -1px !important;
      margin-right: -1px !important;
    }

    .form-group {
      margin-bottom: 0;
    }
  }

  .row .form-group:not(#dawnSelect__main-wrapper) {
    margin: 0;
    padding: 0;
    padding-left: 1px;
    position: relative;
    z-index: 2;

    .form-control[class] {
      height: 31px;
      margin-bottom: -2px;
      width: calc(100% + 1px);
      padding-top: 8px;
      position: relative;
      top: -1px;
      background: none;
      //text-align: right;
    }
  }
  .row #dawnSelect__main-wrapper {
    //margin-left: -2px !important;
    &.middle {
      margin-top: 10px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }
  }
  .row #dawnSelect__main-wrapper:first-child .dawnSelect {
    border-left: none;
  }

  .dawnSelect[class]:not(.dawnSelect--over) {
    border-top: none;
    border-bottom: none;
    box-shadow: none;
    background-image: none;
    border-color: #ccc;
    height: 27px;
    padding-top: 0px;

    .dawnSelect__tags[class] {
      margin-left: 1px;
    }
    .dawnSelect__input[class] {
      font-size: 12px;
      line-height: 20px;
    }
    .dawnSelect__option[class] {
      font-size: 12px;
    }
    .dawnSelect__header-wrapper[class] {
      margin-top: -28px;
      padding-top: 4px;
    }
    .dawnSelect__header-wrapper[class],
    .dawnSelect__content-wrapper[class] {
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
    }
  }

  .well > {
    .content.rule-action-group {
      background: #f7f7f7;
    }
    .toolbar {
      background: #eee;
      border: 1px solid #ccc;
      padding: 0 10px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Approvals/Approval-rule/rule.vue